<template>
  <div class="game-container">
     <!-- <button @click="closeIframe">关闭iframe</button> -->
    <iframe
      v-if="isIframeVisible"
      :src="gameUrl"
      frameborder="0"
      class="game-iframe"
      allowFullscreen
    ></iframe>
    <!-- 确认弹窗 -->
    <!-- <div v-if="showConfirm" class="confirm-mask">
      <div class="confirm-box">
        <p>确定要退出游戏吗？</p>
        <div class="btns">
          <button @click="doBack">确定</button>
          <button @click="showConfirm = false">取消</button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
 props: {
  gameUrl: {
    type: String,
    required: true
  }
 },
 data() {
  return {
    isIframeVisible: true,
    showConfirm: false
  };
 },
 methods: {
    closeIframe() {
      this.showConfirm = true;
      this.$emit('close');
    },
    doBack() {
      this.showConfirm = false;
      this.$emit("close"); // 通知父组件关闭
    }
  }
};
</script>

<style scoped>
.game-container {
  position: fixed;
  inset: 0;
  background: #000;
  display: flex;
  flex-direction: column;
}

.toolbar {
  background: #222;
  padding: 10px;
  text-align: left;
}
.back-btn {
  color: #fff;
  background: #ff4d4f;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.game-iframe {
  flex: 1;
  width: 100%;
  border: none;
}

/* 确认弹窗 */
.confirm-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirm-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-width: 260px;
  text-align: center;
}
.confirm-box .btns {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}
.confirm-box button {
  padding: 6px 12px;
  cursor: pointer;
}
</style>